(function ($) {
  holidayNavFormatterV1 = {
    formatter: $('.holiday-nav-formatter-v1 ')
  };

  Drupal.behaviors.holidayNavFormatterV1 = {
    get: function (key) {
      return holidayNavFormatterV1[key];
    },

    set: function (key, val) {
      holidayNavFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      // code
      var self = this;
      var formatter = self.get('formatter');
      var holidayCatMenus = formatter.find('.holiday-shop-prod-cat-v1').find('.cat-menu-wrapper');
      var menus = '';

      holidayCatMenus.each(function () {
        var thisMenu = $(this).find('.menu-text');
        var menu_text = thisMenu.text();
        var menu_hashtag = thisMenu.attr('data-hashtag');
        // NOTE: This JS will handle only only sub-menu. If you want to have multiple sub-sub-menus,change the code to recursive. This is designed to handle holiday 2015
        var myParent = $(this).find('.parent-text');

        if (myParent.length > 0) {
          var subMenus = '';
          var allMenus = holidayCatMenus.find('.menu-text').not('.processed');

          allMenus.each(function (i, e) {
            var item = $(e).next('.parent-text');

            if (item.length > 0) {
              if (myParent.first().text() == item.first().text()) {
                // Create li
                subMenus = subMenus + '<li class="menu-text-list"><a href="#" class="menu" data-hashtag="' + $(e).attr('data-hashtag') + '">' + $(e).text() + '</a></li>';
                $(e).addClass('processed');
              }
            }
          });
          if (subMenus != '') {
            menus = menus + '<li class="menu-text-list"><a href="#" class="menu parent">' + myParent.first().text() + '<span class="icon"></span>' + '</a><ul class="child">' + subMenus + '</ul></li>';
          }
        } else {
          menus = menus + '<li class="menu-text-list"><a href="#" class="menu" data-hashtag="' + menu_hashtag + '">' + menu_text + '</a></li>';
        }

        thisMenu.addClass('processed');
      });

      $('.holiday-nav-header ul.holiday-nav').append(menus);
      var holidayMenus = $('.holiday-nav-formatter-v1 .holiday-nav .menu-text-list');

      holidayMenus.on('click', function(e) {
        e.preventDefault();
        if ($(this).find('.menu').hasClass('parent')) {
          $(this).find('.menu').next('ul.child').slideToggle();
        } else {
          holidayMenus.find('.menu').removeClass('active');
          $(this).find('.menu').addClass('active');
          var showProductsByCat = $(this).find('.menu').attr('data-hashtag');

          $('.holiday-shop-prod-cat-v1').hide();
          var catToBeDisplayed = $('#' + showProductsByCat + '.holiday-shop-prod-cat-v1');

          catToBeDisplayed.show();

          // Change the header based on selected category
          $('.holiday-product-header').removeClass().addClass('holiday-product-header ' + showProductsByCat);
          $('.holiday-product-header h3').text(catToBeDisplayed.find('.menu-text').text());

          $('html, body').animate({
            scrollTop: 0
          }, 600);
        }
      });

      $(window).on('hashchange', function (e) {
        var showProductsByCat = window.location.hash.replace('#', '');
        var goToCat = $('.holiday-nav-formatter-v1 .holiday-nav .menu[data-hashtag="' + showProductsByCat + '"]');

        if (goToCat.length > 0) {
          goToCat.trigger('click');
        } else {
          holidayMenus.first().trigger('click');
        }
      });

      if (window.location.hash == '') {
        holidayMenus.first().trigger('click');
      } else {
        var showProductsByCat = window.location.hash.replace('#', '');
        var goToCat = $('.holiday-nav-formatter-v1 .holiday-nav .menu[data-hashtag="' + showProductsByCat + '"]');

        if (goToCat.length > 0) {
          goToCat.trigger('click');
        } else {
          holidayMenus.first().trigger('click');
        }
      }

      // view toggle
      $('.mpp_toggle_view a').on('click', function(e) {
        e.preventDefault();

        var $prodList = $('ul.product-list');

        if ($prodList.hasClass('full_width')) {
          $prodList.removeClass('full_width');
          $(e.target).removeClass('toggle_on');
        } else {
          $prodList.addClass('full_width');
          $(e.target).addClass('toggle_on');
        }
      });
    }
  };
})(jQuery);
